import STRINGS from 'utils/strings'

const HEADER_NAMES = {
  create: {
    ['participant-visit']: STRINGS.visitScheduleCreateNewAdhoc,
    ['visit-templates']: STRINGS.visitScheduleCreateNewVisitSchedule,
    visits: STRINGS.visitScheduleCreateNewVisit,
  },
  edit: {
    ['participant-visit']: STRINGS.visitScheduleEditAdhoc,
    ['visit-templates']: STRINGS.visitScheduleEditVisitSchedule,
    visits: STRINGS.visitScheduleEditVisit,
  },
}

const HEADER_NAMES_WITH_ARM_SUPPORT = {
  create: {
    ['participant-visit']: STRINGS.visitScheduleCreateNewAdhoc,
    ['visit-templates']: STRINGS.visitScheduleCreateArm,
    visits: STRINGS.visitScheduleCreateNewVisit,
  },
  edit: {
    ['participant-visit']: STRINGS.visitScheduleEditAdhoc,
    ['visit-templates']: STRINGS.visitScheduleEditArm,
    visits: STRINGS.visitScheduleEditVisit,
  },
}

const HEADER_NAMES_READ_ONLY = {
  create: {
    ['participant-visit']: STRINGS.visitScheduleCreateNewAdhoc,
    ['visit-templates']: STRINGS.visitScheduleCreateNewVisitSchedule,
    visits: STRINGS.visitScheduleCreateNewVisit,
  },
  edit: {
    ['participant-visit']: STRINGS.visitScheduleViewAdhoc,
    ['visit-templates']: STRINGS.visitScheduleViewVisitSchedule,
    visits: STRINGS.visitScheduleViewVisit,
  },
}

const HEADER_NAMES_WITH_ARM_SUPPORT_READ_ONLY = {
  create: {
    ['participant-visit']: STRINGS.visitScheduleCreateNewAdhoc,
    ['visit-templates']: STRINGS.visitScheduleCreateArm,
    visits: STRINGS.visitScheduleCreateNewVisit,
  },
  edit: {
    ['participant-visit']: STRINGS.visitScheduleViewAdhoc,
    ['visit-templates']: STRINGS.visitScheduleViewArm,
    visits: STRINGS.visitScheduleViewVisit,
  },
}

export const NAV_HEADER_NAMES = {
  ['participant-visit']: 'participant visit',
  ['visit-templates']: 'visit schedule',
  visits: 'visit',
}

export const NAV_HEADER_NAMES_WITH_ARM_SUPPORT = {
  ['participant-visit']: 'participant visit',
  ['visit-templates']: 'arm',
  visits: 'visit',
}

export const getSelectedTab = (path, isArmsSupported, isReadOnlyState) => {
  const getHeaderNames = () => {
    if (isReadOnlyState) {
      return isArmsSupported ? HEADER_NAMES_WITH_ARM_SUPPORT_READ_ONLY : HEADER_NAMES_READ_ONLY
    }
    return isArmsSupported ? HEADER_NAMES_WITH_ARM_SUPPORT : HEADER_NAMES
  }
  const headerNames = getHeaderNames()
  if (headerNames.hasOwnProperty(path)) {
    return 'main'
  }
  return path
}
export const getHeaderName = (route, subroute, isArmsSupported, isReadOnlyState) => {
  const getHeaderNames = () => {
    if (isReadOnlyState) {
      return isArmsSupported ? HEADER_NAMES_WITH_ARM_SUPPORT_READ_ONLY : HEADER_NAMES_READ_ONLY
    }
    return isArmsSupported ? HEADER_NAMES_WITH_ARM_SUPPORT : HEADER_NAMES
  }
  const headerNames = getHeaderNames()
  return subroute && typeof headerNames[route] === 'object' ? headerNames[route][subroute] : headerNames[route]
}
